import React from 'react';
import { Container } from '@mui/material';
import { useAuthenticator } from '../../../../auth/AuthenticationContext';
import { ViewPropertyContentProps } from '../../types/viewPropertyContentProps';
import { SetpointProfileValues } from '../../../shared/setpoint-profile-values';
export const ViewPropertySetpointProfile = ({
  data: property,
}: ViewPropertyContentProps) => {
  const { user } = useAuthenticator();
  const selected = property?.assignableSetpointProfiles?.find(
    (profile) => profile._id === property.setpointProfileId,
  );
  return property ? (
    <Container>
      <SetpointProfileValues
        profile={selected}
        units={user?.preferredUnits ?? 'F'}
      />
    </Container>
  ) : null;
};
